(function () {
  function formatMoney(cents, fmt) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, fmt);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function getRoot(el) {
    return el.closest('[data-product-root]') || document;
  }

  function readConfig(bar) {
    var script = bar.parentElement.querySelector('[data-wyg-config]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function getRingSizeValue(root) {
    var input = root.querySelector('[data-ring-size-selector] [data-ring-size-custom-property]');
    return input && input.value ? input.value.trim() : '';
  }

  function getCurrentVariant(root) {
    var picker = root.querySelector('tf-variant-picker');
    var variantId = root.querySelector('input[name="id"]')?.value;
    if (!picker || !variantId) return null;
    try {
      var variants = JSON.parse(picker.querySelector('script[data-variants]')?.textContent || '[]');
      return variants.find(function (v) { return String(v.id) === String(variantId); }) || null;
    } catch (err) {
      return null;
    }
  }

  function getVariantExtra(root) {
    var picker = root.querySelector('tf-variant-picker');
    var jsonEl = picker && picker.querySelector('script[data-variant-extra]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function getModalThumbs(modal) {
    return Array.from(modal.querySelectorAll('[data-wyg-thumb]'));
  }

  function setActiveThumb(modal, thumb) {
    if (!thumb) return;
    var mainImg = modal.querySelector('[data-wyg-main-image]');
    var src = thumb.getAttribute('data-media-src');
    var mediaId = thumb.getAttribute('data-media-id');

    getModalThumbs(modal).forEach(function (btn) {
      var match = btn.getAttribute('data-media-id') === mediaId;
      btn.classList.toggle('is-active', match);
    });

    if (mainImg && src) {
      mainImg.src = src;
      if (mediaId) mainImg.setAttribute('data-media-id', mediaId);
    }

    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function stepThumb(modal, dir) {
    var thumbs = getModalThumbs(modal);
    if (!thumbs.length) return;
    var unique = [];
    var seen = {};
    thumbs.forEach(function (t) {
      var id = t.getAttribute('data-media-id');
      if (!seen[id]) {
        seen[id] = true;
        unique.push(t);
      }
    });
    var activeIdx = unique.findIndex(function (t) { return t.classList.contains('is-active'); });
    if (activeIdx < 0) activeIdx = 0;
    var nextIdx = activeIdx + dir;
    if (nextIdx < 0) nextIdx = unique.length - 1;
    if (nextIdx >= unique.length) nextIdx = 0;
    setActiveThumb(modal, unique[nextIdx]);
  }

  function updateGalleryForVariant(modal, variant, root) {
    if (!variant || !modal) return;
    var extra = getVariantExtra(root);
    var mediaId = extra && extra[variant.id] ? Number(extra[variant.id].featured_media_id) : 0;
    if (!mediaId) return;
    var thumb = modal.querySelector('[data-wyg-thumb][data-media-id="' + mediaId + '"]');
    if (thumb) setActiveThumb(modal, thumb);
  }

  function initAccordions(modal) {
    if (modal.dataset.wygAccordionInit) return;
    modal.dataset.wygAccordionInit = 'true';

    modal.querySelectorAll('[data-wyg-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wyg-config__item');
        var body = item && item.querySelector('.wyg-config__body');
        if (!item || !body) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
      });
    });
  }

  function initGallery(modal) {
    var gallery = modal.querySelector('[data-wyg-gallery]');
    if (!gallery || gallery.dataset.wygGalleryInit) return;
    gallery.dataset.wygGalleryInit = 'true';

    getModalThumbs(modal).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveThumb(modal, thumb);
      });
    });

    var prevBtn = modal.querySelector('[data-wyg-thumb-prev]');
    var nextBtn = modal.querySelector('[data-wyg-thumb-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { stepThumb(modal, -1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stepThumb(modal, 1); });
  }

  function setRowValues(container, selector, value) {
    if (!container || value == null) return;
    container.querySelectorAll(selector).forEach(function (el) {
      el.textContent = value;
    });
  }

  function updateBar(bar, variant, cfg) {
    var root = getRoot(bar);

    bar.querySelectorAll('[data-wyg-option-index]').forEach(function (chip) {
      var idx = parseInt(chip.getAttribute('data-wyg-option-index'), 10);
      var valEl = chip.querySelector('.chip-value');
      if (!valEl || !variant) return;
      var val = idx === 0 ? variant.option1 : idx === 1 ? variant.option2 : variant.option3;
      if (val) valEl.textContent = val;
    });

    var ringValEl = bar.querySelector('[data-wyg-ring-size-chip-value]');
    if (ringValEl && cfg.hasRingSize) {
      var ringVal = getRingSizeValue(root);
      ringValEl.textContent = ringVal || cfg.chooseSizeText || 'Choose size';
    }
  }

  function updateModal(modal, variant, cfg, root) {
    var priceEl = modal.querySelector('[data-wyg-modal-price]');
    var atcBtn = modal.querySelector('[data-wyg-modal-atc]');
    var soldoutText = atcBtn ? atcBtn.getAttribute('data-soldout') || 'Sold out' : 'Sold out';
    var addText = atcBtn ? atcBtn.querySelector('.text') : null;
    var defaultAddText = atcBtn && atcBtn.dataset.wygAddText
      ? atcBtn.dataset.wygAddText
      : (addText ? addText.textContent.trim() : 'Add to bag');

    if (priceEl && variant) {
      priceEl.textContent = formatMoney(variant.price, cfg.moneyFormat);
    }

    modal.querySelectorAll('[data-wyg-config-option]').forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-wyg-config-option'), 10);
      if (!variant) return;
      var val = idx === 0 ? variant.option1 : idx === 1 ? variant.option2 : variant.option3;
      setRowValues(row, '[data-wyg-config-value]', val);
    });

    var ringRow = modal.querySelector('[data-wyg-config-ring-size]');
    if (ringRow && cfg.hasRingSize) {
      var ringVal = getRingSizeValue(root);
      setRowValues(ringRow, '[data-wyg-config-ring-value]', ringVal || cfg.chooseSizeText || 'Choose size');
    }

    if (atcBtn) {
      var disabled = !variant || !variant.available;
      atcBtn.classList.toggle('disabled', disabled);
      atcBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      if (addText) {
        addText.textContent = disabled ? soldoutText : defaultAddText;
      }
    }

    updateGalleryForVariant(modal, variant, root);
  }

  function initBar(bar) {
    if (bar.dataset.wygInit) return;
    bar.dataset.wygInit = 'true';

    var cfg = readConfig(bar);
    var root = getRoot(bar);
    var modalId = bar.querySelector('modal-opener')?.getAttribute('data-modal');
    var modal = modalId ? document.querySelector(modalId) : null;

    if (modal) {
      initGallery(modal);
      initAccordions(modal);
    }

    function syncFromVariant(variant) {
      updateBar(bar, variant, cfg);
      if (modal) updateModal(modal, variant, cfg, root);
    }

    root.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      syncFromVariant(variant);
    });

    document.addEventListener('ring-size:change', function (e) {
      var selector = e.target.closest('[data-ring-size-selector]');
      if (!selector) return;
      var eventRoot = selector.closest('[data-product-root]');
      if (!eventRoot || eventRoot !== root) return;
      syncFromVariant(getCurrentVariant(root));
    });

    syncFromVariant(getCurrentVariant(root));

    var openerBtn = bar.querySelector('modal-opener button');
    if (openerBtn && modal) {
      openerBtn.addEventListener('click', function () {
        syncFromVariant(getCurrentVariant(root));
      });
    }

    if (modal) {
      var atcBtn = modal.querySelector('[data-wyg-modal-atc]');
      if (atcBtn && !atcBtn.dataset.wygAtcInit) {
        atcBtn.dataset.wygAtcInit = 'true';
        var addTextEl = atcBtn.querySelector('.text');
        if (addTextEl && !atcBtn.dataset.wygAddText) {
          atcBtn.dataset.wygAddText = addTextEl.textContent.trim();
        }
        atcBtn.addEventListener('click', function () {
          if (atcBtn.classList.contains('disabled')) return;
          var mainAtc = root.querySelector('tf-buy-actions [data-action="add-to-bag"]');
          if (mainAtc) mainAtc.click();
          if (typeof modal.hide === 'function') modal.hide();
        });
      }
    }
  }

  function mountAll(scope) {
    (scope || document).querySelectorAll('[data-what-youll-get-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(); }, { once: true });
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    mountAll(e.target);
  });
})();
